import { combineReducers } from '@reduxjs/toolkit';
import localeReducer from './locale';
import preferencesReducer from './preferences';
import profileReducer from './profile';
import _userSharedSelectors from './selectors';

export * from './locale';
export * from './preferences';
export * from './profile';
export const userSharedSelectors = _userSharedSelectors;

const userReducer = combineReducers({
  profile: profileReducer,
  preferences: preferencesReducer,
  locale: localeReducer
});

export default userReducer;
